import { render, staticRenderFns } from "./CameraImage.vue?vue&type=template&id=caeeead0&scoped=true"
import script from "./CameraImage.vue?vue&type=script&lang=js"
export * from "./CameraImage.vue?vue&type=script&lang=js"
import style0 from "./CameraImage.vue?vue&type=style&index=0&id=caeeead0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caeeead0",
  null
  
)

export default component.exports